module.exports = __webpack_public_path__ + "static/img/102271.dc58cb29.png";